import Axios from '@/common/require'
export default{
  GET_BANNER_LIST(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/banner/index',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  GET_BANNER_INFO(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/banner/info',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  UPDATE_BANNER(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/banner/update',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  CREATE_BANNER(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/banner/create',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  DEL_BANNER(store,data){
    return new Promise((resolve, reject) =>{
      Axios({
        url:'/api.php/console/banner/delete',
        data,
        options:{
          method:'post',
          json:0,
          load:1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/banner/actions.js